import { DocumentNode } from 'apollo-link'

export function getOperationNameFromQuery( gqlDoc: DocumentNode ) {
	const docNode = gqlDoc.definitions.find( ( d ) => d.kind === 'OperationDefinition' )

	// apollo-link doesn't export the OperationDefinitionNode type, helpfully.
	// But if kind === 'OperationDefinition', that's what we're looking at, so I'm bypassing the type
	return ( docNode as any )?.name?.value ?? ''
}

export default getOperationNameFromQuery
